import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import classnames from 'classnames'
import { EmptyCell, Scrollbar, SpinnerLoader, Switch, Typography } from 'shared/ui'
import { useDetailsContext } from '../detailsContext'
import styles from './styles.module.scss'

export const InstructionsTab = observer(() => {
  const { data, instructionMessageFieldStore, futureKnowledgeBaseDocumentNames } =
    useDetailsContext()
  const [documentNames, setDocumentNames] = useState<string[] | null>(null)
  const instructions = data.settings?.instructions?.value ?? ''
  const knowledgeBaseEnabled = data.settings?.use_knowledge_base?.value ?? false

  useEffect(() => {
    futureKnowledgeBaseDocumentNames?.then(setDocumentNames)
  }, [])

  return (
    <>
      <div className={styles.section}>
        <Typography variant='body-lg-medium' ariaLabel='Instructions'>
          Instructions
        </Typography>
        {instructions && instructionMessageFieldStore ? (
          <Scrollbar autoHeight autoHeightMax={318} indentX={24}>
            <div
              className={styles.instructionsContent}
              dangerouslySetInnerHTML={{ __html: instructionMessageFieldStore.messageHtml }}
            />
          </Scrollbar>
        ) : (
          <EmptyCell />
        )}
      </div>

      <div className={classnames(styles.section, styles.secondSection)}>
        <div className={styles.knowledgeBaseRow}>
          <Typography ariaLabel='KnowledgeBase' variant='body-lg-medium'>
            Knowledge Base
          </Typography>
          <Switch value={knowledgeBaseEnabled} ariaLabel='KnowledgeBase' disabled size='middle' />
        </div>
        {knowledgeBaseEnabled && (
          <div className={styles.documentChips}>
            {documentNames === null ? (
              <SpinnerLoader ariaLabel='InstructionsTab' size={18} />
            ) : documentNames.length > 0 ? (
              documentNames.map((name) => (
                <span key={name} className={styles.documentChip}>
                  {name}
                </span>
              ))
            ) : (
              <Typography ariaLabel='docs' variant='body-rg-regular'>
                All documents
              </Typography>
            )}
          </div>
        )}
      </div>
    </>
  )
})
